const blogs = [
	{	
		id: 1,
		title: "روش‌های علمی" 
,
		description: ` روش علمی و اهمیت آن در تحقیقات علمی \n
روش علمی یکی از ابزارهای کلیدی است که دانشمندان و پژوهشگران برای کشف قوانین و اصول حاکم بر پدیده‌ها به کار می‌گیرند. این روش بر پایه این باور بنا شده که پدیده‌ها به‌صورت منظم و قابل پیش‌بینی رخ می‌دهند، و اگر شرایط خاصی فراهم شود، وقوع پدیده‌ها ...`,
		author: " مهندس معین خزایی",
		date: "مهر ۱۴۰۳",
		image: require('../images/blogs/blog_1.jpg'),

	},
	{	
		id: 2,
		title: "اولین گام‌ها در پژوهش علمی",
		description: `انتخاب موضوع \n
انتخاب موضوع تحقیق اولین مرحله و یکی از مهم‌ترین بخش‌های یک پروژه پژوهشی است. انتخاب یک موضوع مناسب نیازمند آشنایی پژوهشگر با اصول، قوانین، و نظریه‌های علمی حوزه‌ای است که در آن تحقیق می‌کند و همچنین شناخت از آخرین پیشرفت‌ها ...`,
		author: " مهندس امیر ملکی‌",
		date: "آبان ماه ۱۴۰۳",
        image: require('../images/blogs/blog_2.jpg'),

	},
	{	
		id: 3,
		title: "فرضیه در پژوهش علمی",
		description: `مقدمه‌ای بر فرضیه \n
 فرضیه در پژوهش علمی یک حدس آگاهانه است که رابطه بین دو یا چند متغیر را بیان می‌کند و در قالب جمله‌ای خبری ارائه می‌شود. فرضیه به‌عنوان یکی از عناصر کلیدی در تحقیقات علمی، نقشی مهم در هدایت مسیر تحقیق و تجزیه و تحلیل داده‌ها دارد. در حقیقت، فرضیه‌ها کمک می‌کنند تا... `,

 		author: " مهندس امیر ملکی‌",
		date: "آبان ماه ۱۴۰۳",
        image: require('../images/blogs/p2.jpg'),

	},
	{	
		id: 4,
		title: "سازه، مفهوم و متغیر در پژوهش",
		description: `تعاریف و انواع\n
یکی از گام‌های کلیدی در تدوین پژوهش علمی، درک و تعریف مفاهیم، سازه‌ها و متغیرهاست. این عناصر نه تنها به پژوهشگر کمک می‌کنند تا موضوع مورد مطالعه را به دقت تعریف کند، بلکه چارچوبی را نیز فراهم می‌آورند که می‌تواند مسیر تحقیق را به سمت اهداف روشن ...`,

		author: " مهندس معین خزایی",
		date: "مهر ۱۴۰۳",
        image: require('../images/blogs/p1.jpg'),

	},
	{	
		id: 5,
		title: "بررسی پیشینه تحقیق",
		description:`رویکردها، اشتباهات رایج و چالش‌های جدید\n 
بررسی پیشینه تحقیق یکی از گام‌های ضروری و حیاتی در فرایند تحقیق علمی است. هدف اصلی از این مرحله، ایجاد شناخت عمیق از زمینه علمی و همچنین دستیابی به نتایج و نظریات قبلی است که به پژوهشگر کمک می‌کند تا مسئله تحقیق خود را به درستی تعریف کرده,`,
		author: " مهندس معین خزایی",
		date: "مهر ۱۴۰۳",
        image: require('../images/blogs/p3.jpg'),

	},

];

export default blogs;